<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_add_choice === true">เพิ่มช้อยส์เรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_edit_choice === true">แก้ไขช้อยส์เรียบร้อยแล้ว</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_delete_choice === true">ลบช้อยส์เรียบร้อยแล้ว</v-alert>
    </v-slide-x-reverse-transition>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_addtopping_manage_food">
                <img src="@/assets/seasoning.png">
            </div>
            <h2 class="title_addtopping_manage_food">แก้ไขท็อปปิ้ง</h2>
        </div>
        <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/managefood')">
            ย้อนกลับ
        </v-btn>
    </div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <v-container>
                <v-form ref="form" @submit.prevent="editTopping()">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="ชื่อท็อปปิ้งภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่อท็อปปิ้งภาษาไทย']" v-model="topingcategory" hide-details="auto" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="ชื่อท็อปปิ้งภาษาอังกฤษ"  v-model="topingcategory_en" hide-details="auto" required outlined></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <div>ลูกค้าจำเป็นต้องเลือก</div>
                            <v-radio-group class="mt-0" v-model="select" hide-details="auto">
                                <div class="d-flex">
                                    <div class="d-flex check_type_addtopping_manage_food">
                                        <v-radio color="primary" value="essential"></v-radio>
                                        <div>จำเป็น</div>
                                    </div>
                                    <div class="d-flex check_type_addtopping_manage_food">
                                        <v-radio color="primary" value="not_essential"></v-radio>
                                        <div>ไม่จำเป็น</div>
                                    </div>
                                </div>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12">
                            <div>ลูกค้าสามารถเลือกได้หลายท็อปปิ้ง</div>
                            <v-radio-group class="mt-0" v-model="selectlimit" hide-details="auto">
                                <div class="d-flex">
                                    <div class="d-flex check_type_addtopping_manage_food">
                                        <v-radio color="primary" hide-details="auto" value="not_limit"></v-radio>
                                        <div>เลือกได้ไม่จำกัด</div>
                                    </div>
                                    <div class="d-flex check_type_addtopping_manage_food">
                                        <v-radio color="primary" hide-details="auto" value="not_more_than"></v-radio>
                                        <div class="mr-2">สูงสุด</div>
                                        <div class="d-flex check_type_addtopping_manage_food">
                                            <div class="d-flex align-center">
                                                <div @click="addNumLimit('minus')" class="cursor_addtopping_manage_food">
                                                    <v-icon size="40">mdi-minus-circle</v-icon>
                                                </div>
                                                <div class="ml-2 mr-2">
                                                    {{ add_num_limit }}
                                                </div>
                                                <div @click="addNumLimit('plus')" class="cursor_addtopping_manage_food">
                                                    <v-icon size="40">mdi-plus-circle</v-icon>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="d-flex check_type_addtopping_manage_food">
                                        <v-radio color="primary" hide-details="auto" value="type_amount"></v-radio>
                                        <div>เลือกแบบใส่จำนวน</div>
                                    </div>
                                </div>
                            </v-radio-group>

                        </v-col>
                        <v-col cols="12">
                            <div>ช้อยส์</div>
                            <v-card class="mb-2" v-for="(choice_detail,key) in choice_list" :key="key">
                                <div class="pa-2 d-flex justify-space-between">
                                    <div>
                                        <div>{{ choice_detail.name }}</div>
                                        <div class="error--text" v-if="choice_detail.food_bom_list.length > 0">การผูกสูตรอาหาร</div>
                                        <div class="error--text" v-for="(food_bom_detail,key_food_bom) in choice_detail.food_bom_list" :key="key_food_bom">
                                        - {{ food_bom_detail.name }} {{ food_bom_detail.use_in }} {{ food_bom_detail.unit_name }}
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="border_choice_addtopping_manage_food d-flex justify-center align-center">{{ choice_detail.price }} ฿</div>
                                        <v-icon class="mx-1" @click="choiceDetail(choice_detail.no)">mdi-pencil-box</v-icon>
                                        <v-icon color="error" @click="confirmDeleteChoice(choice_detail.no)">mdi-close</v-icon>
                                    </div>

                                </div>
                            </v-card>
                            <v-btn width="100%" @click="openAddChoice()">
                                <v-icon>mdi-plus</v-icon> เพิ่มช้อยส์
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4"></v-col>
                        <v-col cols="4">
                            <v-btn color="#28ab28" class="white--text titlefont_addtopping_manage_food d-flex justify-center align-center" type="submit" height="50" width="100%">
                                บันทึก
                            </v-btn>
                        </v-col>
                        <v-col cols="4"></v-col>
                    </v-row>
                </v-form>
            </v-container>
            <v-dialog v-model="open_add_choice" persistent max-width="900px">
                <div v-if="loading_add_choice_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_add_choice_page === false">
                    <v-form ref="form_choice" @submit.prevent="addChoice()">
                        <v-card-title>
                            <div class="d-flex">
                                <v-icon>mdi-plus</v-icon> เพิ่มช้อยส์
                            </div>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field label="ชื่อช้อยส์ภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่อช้อยส์ภาษาไทย']" v-model="add_choice_name" required outlined></v-text-field>
                                        <v-text-field label="ชื่อช้อยส์ภาษอังกฤษ"  v-model="add_choice_name_en" required outlined></v-text-field>
                                        <div>
                                            เลือกช้อยส์นี้มีการเปลี่ยนแปลงอย่างไรกับเมนู
                                        </div>
                                        <v-radio-group class="mt-0" v-model="choice_price">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex">
                                                    <v-radio color="primary" value="not_price"></v-radio>
                                                    <div>ไม่เปลี่ยนแปลง</div>
                                                </div>
                                                <div class="d-flex">
                                                    <v-radio color="primary" value="price"></v-radio>
                                                    <div>ราคาเพิ่มขึ้น</div>
                                                </div>
                                            </div>
                                        </v-radio-group>

                                        <v-text-field label="บาท" :rules="[v => !!v || 'กรุณากรอกราคาที่เพิ่มขึ้น']" v-model="price" type="number" outlined v-if="choice_price === 'price'" required></v-text-field>

                                    </v-col>
                                </v-row>
                                <v-row class="mt-3">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            <div class="pr-2" style="font-size: 18px !important"><b>การผูกสูตรอาหาร</b></div>
                                            <div class="grey--text" style="font-size: 18px !important">(สามารถเพิ่มได้หลายวัตถุดิบ)</div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="mt-n1 mr-1">
                                            <v-autocomplete :items="list_menu" item-text="name" item-value="id" @input="add_material(material_id)" v-model="material_id" prepend-inner-icon="mdi-magnify" label="เลือกวัตถุดิบ" hide-details="auto" outlined></v-autocomplete>
                                        </div>
                                    </v-col>
                                    <v-col>
                                        <div>
                                            <v-data-table :headers="material_header" :items="data_list" :items-per-page="-1" mobile-breakpoint="0" hide-default-footer>
                                                <template slot="item" slot-scope="dataDetail">
                                                    <tr class="text-center">
                                                        <td>
                                                            <v-btn color="red" small height="42" class="white--text mb-1" @click="getDelete(dataDetail.item.loop_id)">
                                                            <v-icon>mdi-window-close</v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td>{{ dataDetail.item.name }}</td>
                                                        <td class="pa-3">
                                                            <v-text-field type="number" min="0" :rules="[v => !!v || 'กรุณากรอกจำนวน']" @keypress="onlyForCurrency($event, dataDetail.item.material_input)" v-model="dataDetail.item.material_input" hide-details="auto" outlined></v-text-field>
                                                        </td>
                                                        <td>{{ dataDetail.item.unit_name }}</td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                            <v-divider/>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#28ab28" class="white--text" type="submit" height="50">
                                บันทึก
                            </v-btn>
                            <v-btn color="error" height="50" type="button" @click="open_add_choice = false">
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog v-model="open_edit_choice" persistent max-width="900px">
                <div v-if="loading_detail_choice_page === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_detail_choice_page === false">
                    <v-form ref="form_choice_edit" @submit.prevent="editChoice()">
                        <v-card-title>
                            <div class="d-flex">
                                <v-icon>mdi-plus</v-icon> แก้ไขช้อยส์
                            </div>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field label="ชื่อช้อยส์ภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่อช้อยส์ภาษาไทย']" v-model="add_choice_name" required outlined></v-text-field>
                                        <v-text-field label="ชื่อช้อยส์ภาษาอังกฤษ"  v-model="add_choice_name_en" required outlined></v-text-field>
                                        <div>
                                            เลือกช้อยส์นี้มีการเปลี่ยนแปลงอย่างไรกับเมนู
                                        </div>
                                        <v-radio-group class="mt-0" v-model="choice_price">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex">
                                                    <v-radio color="primary" value="not_price"></v-radio>
                                                    <div>ไม่เปลี่ยนแปลง</div>
                                                </div>
                                                <div class="d-flex">
                                                    <v-radio color="primary" value="price"></v-radio>
                                                    <div>ราคาเพิ่มขึ้น</div>
                                                </div>
                                            </div>
                                        </v-radio-group>

                                        <v-text-field label="บาท" :rules="[v => !!v || 'กรุณากรอกราคาที่เพิ่มขึ้น']" v-model="price" type="number" outlined v-if="choice_price === 'price'" required></v-text-field>

                                    </v-col>
                                </v-row>
                                <v-row class="mt-3">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            <div class="pr-2" style="font-size: 18px !important"><b>การผูกสูตรอาหาร</b></div>
                                            <div class="grey--text" style="font-size: 18px !important">(สามารถเพิ่มได้หลายวัตถุดิบ)</div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="mt-n1 mr-1">
                                            <v-autocomplete :items="list_menu" item-text="name" item-value="id" @input="add_material(material_id)" v-model="material_id" prepend-inner-icon="mdi-magnify" label="เลือกวัตถุดิบ" hide-details="auto" outlined></v-autocomplete>
                                        </div>
                                        </v-col>
                                        <v-col>
                                        <div>
                                            <v-data-table :headers="material_header" :items="data_list" :items-per-page="-1" mobile-breakpoint="0" hide-default-footer>
                                                <template slot="item" slot-scope="dataDetail">
                                                    <tr class="text-center">
                                                        <td>
                                                            <v-btn color="red" small height="42" class="white--text mb-1" @click="getDelete(dataDetail.item.loop_id)">
                                                            <v-icon>mdi-window-close</v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td>{{ dataDetail.item.name }}</td>
                                                        <td class="pa-3">
                                                            <v-text-field type="number" min="0" :rules="[v => !!v || 'กรุณากรอกจำนวน']" @keypress="onlyForCurrency($event, dataDetail.item.material_input)" v-model="dataDetail.item.material_input" hide-details="auto" outlined></v-text-field>
                                                        </td>
                                                        <td>{{ dataDetail.item.unit_name }}</td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                            <v-divider/>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#28ab28" class="white--text" type="submit" height="50">
                                บันทึก
                            </v-btn>
                            <v-btn color="error" height="50" type="button" @click="open_edit_choice = false">
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
    <v-dialog v-model="open_confirm_choice_delete" persistent max-width="600px">
        <div v-if="loading_detail_choice_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_detail_choice_page === false">
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                ต้องการลบช้อยส์ {{ delete_name_choice }} ใช่หรือไม่ ?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" height="50" @click="removeChoice()">
                    บันทึก
                </v-btn>
                <v-btn color="error" height="50" @click="cancelConfirmChoiceDelete()">
                    ยกเลิก
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
    <v-dialog v-model="alert_show_add" persistent max-width="600">
        <v-card>
            <v-card-title>
                สำเร็จ
            </v-card-title>

            <v-card-text>
                แก้ไขท็อปปิ้งเรียบร้อย
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" text @click="confirmSuccess()">
                    ตกลง
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script src="@/previewimage.js"></script><script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'toppingDetail',
    data() {
        return {
            loading_page: true,
            loading_add_choice_page: false,
            loading_detail_choice_page: true,
            id_topping: null,
            add_num_limit: 1,
            open_add_choice: false,
            topingcategory: null,
            topingcategory_en: null,
            select: "essential",
            selectlimit: "not_limit",
            choice_list: [],
            no: 0,
            add_choice_name: null,
            add_choice_name_en: null,
            choice_price: 'not_price',
            price: null,
            open_edit_choice: false,
            edit_choice_no: null,
            alert_show_add: false,
            alert_add_choice: false,
            alert_edit_choice: false,
            delete_name_choice: null,
            open_confirm_choice_delete: false,
            alert_delete_choice:false,
            list_menu_default: [],
            list_menu: [],
            material_id: null,
            material_header: [
                {
                text: '',
                value: '',
                sortable: false,
                fixed: true,
                width: '150px',
                align: 'center',
                },
                {
                text: 'วัตถุดิบ',
                value: '',
                sortable: false,
                fixed: true,
                width: '250px',
                align: 'center',
                },
                {
                text: 'จำนวน',
                value: '',
                sortable: false,
                fixed: true,
                width: '200px',
                align: 'center',
                },
                {
                text: 'หน่วยนับ',
                value: '',
                sortable: false,
                fixed: true,
                width: '200px',
                align: 'center',
                },
            ],
            data_list: [],
            loop_id: 0,
        }
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    methods: {
        async getData() {
            await this.receipt()
            await HTTP.get('/toping/edit/' + this.$store.state.detailToppingId, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.id_topping = response.data.topingdetail.id
                        this.topingcategory = response.data.topingdetail.name
                        this.topingcategory_en = response.data.topingdetail.name_en
                        this.choice_list = []
                        if (response.data.topingdetail.choose == 0) {
                            this.select = 'not_essential'
                        }
                        if (response.data.topingdetail.choose == 1) {
                            this.select = 'essential'
                        }
                        if (response.data.topingdetail.status_limit == 0) {
                            this.selectlimit = 'not_limit'
                        }
                        if (response.data.topingdetail.status_limit == 1) {
                            this.selectlimit = 'not_more_than'
                        }
                        if (response.data.topingdetail.status_limit == 2) {
                            this.selectlimit = 'type_amount'
                        }
                        this.add_num_limit = parseInt(response.data.topingdetail.limit)
                        response.data.topingdetail.topingList.forEach(detail => {
                            this.no += 1
                            let food_bom_list = []
                            detail.food_bom_list.forEach((detail_food_bom) => {
                                food_bom_list.push({
                                    id: detail_food_bom.id,
                                    mat_id: detail_food_bom.mat_id,
                                    name: detail_food_bom.name,
                                    unit_id: detail_food_bom.unit_id,
                                    unit_name: detail_food_bom.unit_name,
                                    use_in: detail_food_bom.use_in,
                                })
                            })
                            this.choice_list.push({
                                id: detail.id,
                                no: this.no,
                                name: detail.name,
                                name_en: detail.name_en,
                                price: detail.price,
                                food_bom_list: food_bom_list
                            })
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        onlyForCurrency(evt, number) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            }
            // restrict to 2 decimal places
            else if (number !== null && number.indexOf(".") > -1 && (number.split('.')[1].length >= 2)) {
                evt.preventDefault();
            } else {
                return true
            }
        },
        async addNumLimit(type) {
            if (type === 'plus') {
                this.add_num_limit += 1
            }
            if (type === 'minus' && this.add_num_limit > 1) {
                this.add_num_limit -= 1
            }
        },
        async openAddChoice() {
            this.open_add_choice = true
            this.add_choice_name = null
            this.add_choice_name_en = null
            this.choice_price = 'not_price'
            this.price = null
            this.list_menu = this.list_menu_default
            this.data_list = []
        },
        async receipt() {
            await HTTP.get('/bom/searchMat', {
                headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
                }
            }).then((response) => {
                if (response.data.successful === true) {
                this.list_menu_default = response.data.mat
                this.list_menu = response.data.mat
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
                }
            })
        },
        async add_material(mat_id) {
            let value = this.list_menu.find((res) => {
                return res.id === mat_id
            })
            this.list_menu = this.list_menu.filter((res) => {
                return res.id != mat_id
            })

            let loop_id = this.loop_id += 1
            this.data_list.push({
                loop_id: loop_id,
                id: null,
                mat_id: value.id,
                unit_id: value.unit_id,
                name: value.name,
                material_input: null,
                unit_name: value.unit_name,
            })

            await this.$nextTick(() => {
                this.material_id = null
            })
        },
        async getDelete(loop_id) {
            const value = this.data_list.find((detail) => {
                return detail.loop_id === loop_id
            })
            this.list_menu.push({
                id: value.id,
                name: value.name,
                unit_id: value.unit_id,
                unit_name: value.unit_name,
            })
            this.data_list = this.data_list.filter(detail => detail.loop_id != loop_id)
            this.list_menu.sort((a, b) => {
                let fa = a.name.toLowerCase(),
                    fb = b.name.toLowerCase();

                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            })
            this.material_id = null
        },
        async addChoice() {
            if (this.$refs.form_choice.validate()) {
                this.loading_add_choice_page = true
                let result_price = 0
                if (this.price > 0) {
                    result_price = this.price
                }
                this.no += 1

                if (this.choice_price == 'not_price') {
                    result_price = 0
                }
                let food_bom_list = []
                this.data_list.forEach(detail => {
                    food_bom_list.push({
                        mat_id: detail.mat_id,
                        use_in: detail.material_input,
                        unit_id: detail.unit_id,
                    })
                })

                HTTP.post('/toping_add_choice/' + this.id_topping, {
                    name: (this.add_choice_name || '').replace(this.$store.state.checkEmoji, ""),
                    name_en: (this.add_choice_name_en || '').replace(this.$store.state.checkEmoji, ""),
                    price: result_price,
                    food_bom_list: food_bom_list,
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                }).then((response) => {
                    if (response.data.successful === true) {
                        this.open_add_choice = false
                        this.loading_add_choice_page = false
                        this.loading_page = true
                        this.getData()
                        this.alert_add_choice = true
                        setTimeout(() => this.alert_add_choice = false, 5000)
                    }
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }

        },
        async choiceDetail(no) {
            this.open_edit_choice = true
            const choice = this.choice_list.find(detail => detail.no == no)
            this.edit_choice_no = choice.no
            this.add_choice_name = choice.name
            this.add_choice_name_en = choice.name_en
            this.choice_price = 'not_price'
            if (parseInt(choice.price) > 0) {
                this.choice_price = 'price'
            }
            this.price = choice.price
            this.list_menu = this.list_menu_default
            this.data_list = []
            this.loop_id += 1
            choice.food_bom_list.forEach(detail => {
                this.list_menu = this.list_menu.filter((res) => {
                    return res.id != detail.mat_id
                })
                this.data_list.push({
                    loop_id: this.loop_id,
                    id: detail.id,
                    mat_id: detail.mat_id,
                    name: detail.name,
                    name_en: detail.name_en,
                    unit_id: detail.unit_id,
                    unit_name: detail.unit_name,
                    material_input: detail.use_in,
                })
                this.loop_id += 1
            })
            this.loading_detail_choice_page = false
        },
        async editChoice() {
            if (this.$refs.form_choice_edit.validate()) {
                let choice = this.choice_list.find(detail => detail.no == this.edit_choice_no)
                if (choice.id) {
                    this.loading_detail_choice_page = true
                    let food_bom_list = []
                    this.data_list.forEach(detail => {
                        food_bom_list.push({
                            id: detail.id,
                            mat_id: detail.mat_id,
                            name: detail.name,
                            name_en: detail.name_en,
                            use_in: detail.material_input,
                            unit_id: detail.unit_id,
                            unit_name: detail.unit_name,
                        })
                    })

                    this.price = this.choice_price == 'not_price' ? '0.00' : this.price
                    HTTP.post('/toping_detail_choice_update/' + choice.id, {
                        name: (this.add_choice_name || '').replace(this.$store.state.checkEmoji, ""),
                         name_en: (this.add_choice_name_en || '').replace(this.$store.state.checkEmoji, ""),
                            price: this.price,
                            food_bom_list: food_bom_list,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        }).then((response) => {
                            if (response.data.successful === true) {

                                choice.name = this.add_choice_name
                                choice.name_en = this.add_choice_name_en
                                choice.price = this.price
                                this.open_edit_choice = false
                                this.loading_detail_choice_page = false
                                this.loading_page = true
                                this.getData()
                                this.alert_edit_choice = true
                                setTimeout(() => this.alert_edit_choice = false, 5000)
                            }
                        })
                        .catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
                if (!choice.id) {
                    choice.name = this.add_choice_name
                    choice.name_en = this.add_choice_name_en
                    choice.price = this.price
                    this.open_edit_choice = false
                    this.alert_edit_choice = true
                    setTimeout(() => this.alert_edit_choice = false, 5000)
                }
            }
        },
        async confirmDeleteChoice(no) {
            this.open_confirm_choice_delete = true
            const choice = this.choice_list.find(detail => detail.no == no)
            this.edit_choice_no = choice.no
            this.delete_name_choice = choice.name
            this.loading_detail_choice_page = false
        },
        async cancelConfirmChoiceDelete() {
            this.open_confirm_choice_delete = false
            this.edit_choice_no = null
            this.delete_name_choice = null
        },
        async removeChoice() {
            this.loading_detail_choice_page = true
            let choice = this.choice_list.find(detail => detail.no == this.edit_choice_no)
            if (choice.id) {
                HTTP.post('/toping/delete-choice/' + choice.id, null, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    }).then((response) => {
                        if (response.data.successful === true) {
                            this.choice_list = this.choice_list.filter(detail => detail.no != this.edit_choice_no)
                            this.open_confirm_choice_delete = false
                            this.loading_detail_choice_page = false
                            this.loading_page = true
                            this.getData()
                            this.alert_delete_choice = true
                            setTimeout(() => this.alert_delete_choice = false, 5000)
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (!choice.id) {
                this.choice_list = this.choice_list.filter(detail => detail.no != this.edit_choice_no)
                this.open_confirm_choice_delete = false
                this.loading_detail_choice_page = false
                this.alert_delete_choice = true
                setTimeout(() => this.alert_delete_choice = false, 5000)
            }

        },
        async editTopping() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                let necessary = ''
                let notnecessary = ''
                let unlimit = ''
                let limit = ''
                let amount = ''
                let type_amount = ''

                if (this.select === 'essential') {
                    necessary = 1
                }
                if (this.select === 'not_essential') {
                    notnecessary = 1
                }

                if (this.selectlimit === 'not_limit') {
                    unlimit = 1
                }
                if (this.selectlimit === 'not_more_than') {
                    limit = 1
                }
                if (this.add_num_limit > 0) {
                    amount = this.add_num_limit
                }
                if (this.selectlimit === 'type_amount') {
                    type_amount = 1
                }

                HTTP.post('/toping/update/' + this.id_topping, {
                        topingcategory: (this.topingcategory || '').replace(this.$store.state.checkEmoji, ""),
                        topingcategory_en: (this.topingcategory_en || '').replace(this.$store.state.checkEmoji, ""),
                       
                        necessary: necessary,
                        notnecessary: notnecessary,
                        unlimit: unlimit,
                        limit: limit,
                        amount: amount,
                        type_amount: type_amount,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    }).then((response) => {
                        if (response.data.successful === true) {
                            this.alert_show_add = true
                            this.loading_page = false
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async confirmSuccess() {
            this.$router.push('/managefood')
        }
    },
    mounted() {
        this.getData()
    }
}
</script>
